export default __webpack_public_path__ + "static/media/followone-footer-branding.8f6b4da8.png";